import React from 'react';
import { View, StyleSheet, Text, Platform, Image } from 'react-native';
import { TrackingBarGraph } from '../components/tracking-bar-graph';
import { translate } from 'react-i18next';
import Theme from '../../theme';
import UpArrowIcon from '../../assets/images/arrow-up.svg';
import DownArrowIcon from '../../assets/images/arrow-down.svg';
import { defaultScale, scaleText } from '../../utils/scaling';
import { TrackingGauge } from '../../ui/components/TrackingGauge';

const isSmallMobile = window.innerWidth <= 350;
const isWeb = Platform.OS === 'web';

class TrackingWorkoutStandardStats extends React.Component {
  render() {

    const { t } = this.props;
    return (
      this.props.standardStats.map((standardStat) => {
        return (
          standardStat.valAndUnit &&
          <View style={styles.container}>
            <Text style={styles.totalWorkoutsAlt}>{t(standardStat.description)}</Text>
            <View style={styles.containerAlt}>
              <View style={styles.statContainer}>
                {
                  standardStat.trackingGaugedata
                    ?
                    <React.Fragment>
                      <View style={styles.gaugeContainer}>
                        <TrackingGauge
                          data={standardStat.trackingGaugedata}
                          valAndUnit={standardStat.valAndUnit}
                          valuePercent={standardStat.valuePercent}
                          radius={defaultScale(40)}
                          smallCircleRadius={defaultScale(6)}
                          strokeWidth={defaultScale(8)}
                          centerTextStyle={styles.text}
                        />
                        <View style={styles.statDescriptionContainer}>
                          {
                            Math.sign(standardStat.changeVal) === -1 &&
                            <DownArrowIcon height={defaultScale(12)} width={defaultScale(10)} fill={Theme.BLACK} />
                          }
                          {
                            Math.sign(standardStat.changeVal) === 1 &&
                            <UpArrowIcon height={defaultScale(12)} width={defaultScale(10)} fill={Theme.BLACK} />
                          }
                          {
                            standardStat.changeVal &&
                            <Text style={styles.statPercentage}>{Math.sign(standardStat.changeVal) === -1 ?
                              `${standardStat.changeVal * -1 + standardStat.changeUnit} down from` : `${standardStat.changeVal + standardStat.changeUnit} up on`} last month</Text>
                          }
                        </View>
                      </View>
                    </React.Fragment>
                    :
                    <React.Fragment>
                      <Text style={styles.statValue}>{`${standardStat.valAndUnit}`}</Text>
                      <View style={styles.statDescriptionContainer}>
                        {
                          Math.sign(standardStat.changeVal) === -1 &&
                          <DownArrowIcon height={defaultScale(12)} width={defaultScale(10)} fill={Theme.BLACK} />
                        }
                        {
                          Math.sign(standardStat.changeVal) === 1 &&
                          <UpArrowIcon height={defaultScale(12)} width={defaultScale(10)} fill={Theme.BLACK} />
                        }
                        {
                          standardStat.changeVal &&
                          <Text style={styles.statPercentage}>{Math.sign(standardStat.changeVal) === -1 ?
                            `${standardStat.changeVal * -1 + standardStat.changeUnit} down from` : `${standardStat.changeVal + standardStat.changeUnit} up on`} last month</Text>
                        }
                      </View>
                    </React.Fragment>
                }
              </View>
              <View style={styles.barGraphContainer}>
                {
                  standardStat.graphDataPoints &&
                  <TrackingBarGraph graphDataPoints={standardStat.graphDataPoints} changeUnit={standardStat.changeUnit}
                    graphYAxis={standardStat.graphYAxis} />
                }

              </View>
            </View>
          </View>
        )
      })
    )
  }
}

const textOffset = 10;
const textWidth = 105 - (textOffset * 2);
const textHeight = 105 * (1 - 90 / 360) - (textOffset * 2);

const styles = StyleSheet.create({
  container: {
    flexDirection: 'column',
    borderRadius: defaultScale(3),
    backgroundColor: Theme.WHITE,
    width: '100%',
    marginBottom: defaultScale(15),
  },
  containerAlt: {
    flexDirection: 'row',
  },
  statContainer: {
    alignSelf: 'flex-start',
    width: '48%',
    justifyContent: 'center',
    paddingLeft: defaultScale(12)
  },
  statDescriptionContainer: {
    flexDirection: 'row',
    marginTop: defaultScale(-20),
    marginBottom: defaultScale(10),
    alignItems: 'center',
  },
  barGraphContainer: {
    width: '48%',
    marginRight: defaultScale(50),
    justifyContent: 'center',
    marginTop: !isWeb && defaultScale(20)
  },
  totalWorkouts: {
    color: '#FFFFFF',
    ...Theme.graphStyle.customMedium16,
    letterSpacing: 0,
    lineHeight: defaultScale(20),
    marginTop: defaultScale(12),
    marginBottom: defaultScale(4),
    alignSelf: !isWeb && 'center',
    flexWrap: 'wrap',
  },
  totalWorkoutsAlt: {
    ...Theme.graphStyle.customMedium16,
    color: Theme.GREY_DARK,
    letterSpacing: 0,
    lineHeight: defaultScale(20),
    marginTop: defaultScale(12),
    marginBottom: defaultScale(4),
    textAlign: 'left',
    flexWrap: 'nowrap',
    paddingLeft: defaultScale(20),
  },
  statValue: {
    fontSize: scaleText(29),
    fontWeight: 'bold',
    lineHeight: defaultScale(35),
    color: Theme.GREY_DARK,
  },
  statPercentage: {
    ...Theme.textStyle.small,
    fontFamily: Theme.Custom500,
    lineHeight: defaultScale(12),
    color: Theme.GREY_DARK,
    marginTop: defaultScale(5),
    marginLeft: defaultScale(3),
  },
  statNoPercentage: {
    fontSize: scaleText(isSmallMobile ? 11 : 12),
    marginBottom: defaultScale(isSmallMobile ? 6 : 0),
    fontFamily: Theme.Custom500,
    lineHeight: defaultScale(12),
    color: Theme.GREY_DARK,
    marginTop: defaultScale(5),
  },
  upArrow: {
    width: defaultScale(10),
    height: defaultScale(12),
    marginRight: defaultScale(4),
    marginTop: defaultScale(5),
    backgroundColor: 'black',
  },
  downArrow: {
    width: defaultScale(10),
    height: defaultScale(12),
    marginRight: defaultScale(4),
    marginTop: defaultScale(6),
    backgroundColor: 'black',
  },
  subtitle: {
    color: '#B8B8B8',
    ...Theme.graphStyle.customMedium14,
    fontWeight: '300',
    letterSpacing: 0,
    lineHeight: defaultScale(20),
    marginTop: defaultScale(10),
    marginBottom: defaultScale(10),
  },
  gaugeContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
  gaugeContainerError: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    marginLeft: defaultScale(-20),
  },
  textView: {
    position: 'absolute',
    top: defaultScale(28),
    left: defaultScale(textOffset),
    width: defaultScale(textWidth),
    height: defaultScale(textHeight),
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    ...Theme.graphStyle.customBold22,
    color: Theme.GREY_DARK,
  },
  statDescription: {
    ...Theme.graphStyle.customMedium16,
    color: 'white',
  },
  longStatDescription: {
    ...Theme.graphStyle.customMedium16,
    color: 'white',
    width: defaultScale(130),
    textAlign: !isWeb && 'center',
    flexWrap: 'wrap',
  },
});

export default translate(['workoutHistory'])(TrackingWorkoutStandardStats);